import React from "react";
import { Button } from "components/bootstrap";
import { LinkContainer, Spinner } from "components/common";
import useRunWorkflow from "aiagent/AgentWorkflows/hooks/useRunWorkflow";
import AgentWorkflowRoutes from "aiagent/Routes";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const RunWorkflowButton = ({ workflow, onSuccess }) => {
  const sendTelemetry = useSendTelemetry();
  const currentUser = useCurrentUser();
  const { mutate, isPending } = useRunWorkflow({ type: workflow.id, title: workflow.title, onSuccess });
  const runWorkflow = (event) => {
    event.stopPropagation();
    sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.WORKFLOW_RUN_TRIGGERED, {
      app_section: "aiagent-workflows",
      event_details: { workflow_type: workflow.id }
    });
    mutate();
  };
  if (workflow.active_run_id) {
    if (isPermitted(currentUser.permissions, "agent_workflow:debug")) {
      return /* @__PURE__ */ React.createElement(LinkContainer, { to: AgentWorkflowRoutes.runDetails(workflow.active_run_id) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", title: `A run of ${workflow.title} is in progress. View it.` }, /* @__PURE__ */ React.createElement(Spinner, { text: "View run", delay: 0 })));
    }
    return /* @__PURE__ */ React.createElement(Button, { bsStyle: "warning", disabled: true, title: `A run of ${workflow.title} is already in progress.` }, /* @__PURE__ */ React.createElement(Spinner, { text: "Running\u2026", delay: 0 }));
  }
  const hasConfig = !!((workflow == null ? void 0 : workflow.model) && (workflow == null ? void 0 : workflow.provider));
  const title = hasConfig ? `Run ${workflow.title} workflow` : "Setup provider settings to be able run the workflow.";
  return /* @__PURE__ */ React.createElement(Button, { title, bsStyle: "success", disabled: isPending || !hasConfig, onClick: runWorkflow }, isPending ? "Starting\u2026" : "Run Workflow");
};
export default RunWorkflowButton;
